import { IDetailChangeRevisionOutputModel } from "./../../interfaces/post/index";
import { ROUTE_API } from "constant";
import {
  IBaseDataForPaginate,
  IBaseDataOutputModel,
  ICreateCatePostInputModel,
  ICreatePostOutputModel,
  IGetCatePostOutputModel,
  IGetPostForPaginateInputModel,
  IPostDetailOutputModel,
  IPostRevisionOutputModel,
  IUpdateCatePostInputModel,
} from "interfaces";
import apiV3 from "utils/api.v3";

export const PostServices = {
  /** Post */
  createPost,
  updatePost,
  getPost,
  getDetailPost,
  checkMainTopic,
  checkMainTopicOutstanding,

  /** Cate post */
  getCatePost,
  getDetailCatePost,
  createCatePost,
  updateCatePost,
  deleteCatePost,

  /** Post Revision */
  getListPostRevision,
  getDiffRevisionPost,
};

function createPost(data: FormData) {
  return apiV3.post<ICreatePostOutputModel>(
    { url: ROUTE_API.POST_ROUTE.CREATE_POST, data },
    { "Content-Type": "multipart/form-data" }
  );
}

function updatePost(data: FormData, postId: string) {
  return apiV3.post<ICreatePostOutputModel>(
    { url: ROUTE_API.POST_ROUTE.UPDATE_POST.replace("{POST_ID}", postId), data },
    { "Content-Type": "multipart/form-data" }
  );
}

function checkMainTopic(data: { catePostId: string; postId?: string }) {
  return apiV3.post<IBaseDataOutputModel<IPostDetailOutputModel>>({
    url: ROUTE_API.POST_ROUTE.CHECK_MAIN_TOPIC_BY_CATE_POST,
    data,
  });
}

function checkMainTopicOutstanding(data: { postId?: string }) {
  return apiV3.post<IBaseDataOutputModel<IPostDetailOutputModel>>({
    url: ROUTE_API.POST_ROUTE.CHECK_MAIN_TOPIC_OUTSTANDING,
    data: data,
  });
}

function getPost(data: IGetPostForPaginateInputModel) {
  return apiV3.get<IBaseDataForPaginate<IPostDetailOutputModel>>({ url: ROUTE_API.POST_ROUTE.GET_POSTS, query: data });
}

function getDetailPost(input: { id: string }) {
  return apiV3.get<IBaseDataOutputModel<IPostDetailOutputModel>>({
    url: ROUTE_API.POST_ROUTE.GET_POST_DETAIL.replace("{POST_ID}", input.id),
  });
}

function getCatePost() {
  return apiV3.get<IBaseDataOutputModel<IGetCatePostOutputModel[]>>({ url: ROUTE_API.CATE_POST_ROUTE.GET_CATE_POST });
}

function getDetailCatePost(catePostId: string) {
  return apiV3.get<IBaseDataOutputModel<IGetCatePostOutputModel>>({
    url: ROUTE_API.CATE_POST_ROUTE.GET_CATE_POST_DETAIL.replace("CATE_POST_ID", catePostId),
  });
}

function createCatePost(data: ICreateCatePostInputModel) {
  return apiV3.post<IBaseDataOutputModel<IGetCatePostOutputModel>>({
    url: ROUTE_API.CATE_POST_ROUTE.CREATE_CATE_POST,
    data,
  });
}

function updateCatePost(data: IUpdateCatePostInputModel) {
  return apiV3.put<IBaseDataOutputModel<IGetCatePostOutputModel>>({
    url: ROUTE_API.CATE_POST_ROUTE.UPDATE_CATE_POST.replace("CATE_POST_ID", data.catePostId),
    data,
  });
}

function deleteCatePost(catePostId: string) {
  console.log(78, catePostId);
  return apiV3.delete<IBaseDataOutputModel<IGetCatePostOutputModel>>({
    url: ROUTE_API.CATE_POST_ROUTE.DELETE_CATE_POST.replace("CATE_POST_ID", catePostId),
  });
}

function getListPostRevision(postId: string) {
  return apiV3.get<IBaseDataOutputModel<IPostRevisionOutputModel[]>>({
    url: ROUTE_API.POST_ROUTE.GET_LIST_POST_REVISION.replace("{POST_ID}", postId),
  });
}

function getDiffRevisionPost(postRevisionId: string) {
  return apiV3.get<IBaseDataOutputModel<IDetailChangeRevisionOutputModel[]>>({
    url: ROUTE_API.POST_ROUTE.GET_DIFF_POST_REVISION.replace("{POST_REVISION_ID}", postRevisionId),
  });
}
